import React from 'react';
import { Tabs } from 'antd';

export const LCTabs = (props)  => (
    <Tabs 
        {...props}
    />
);